import store from '@/store/index';
import { hasPermission, getLocationByAMap, getFailDistanceMsg } from '@/util';
import Constant, { CONSULT_TYPE } from '@/lib/constant';
import find from 'lodash/find';
import msgDialog from '@/components/msgDialog';
import router from '@/router';
import Fetch from '@/api';
import { getPackageRenewalNotify } from '@/api';

const baseRole = Constant.RoleList;
function findStoreMana(info) {
  // 找到店长的店铺 不管他是不是兼任的
  const roleP = [baseRole.d];
  if (!hasPermission(roleP)) {
    // 不是店长不去渲染这个数据
    return null;
  }

  const { roleList } = info;
  const storeList = store.getters.storeList;
  let filterStore = roleList.filter(v => {
    if (v.code == baseRole.d) {
      console.log(v);

      // 如果是店长
      return v;
    }
  })[0];
  let handStore = storeList.filter(v => {
    if (v.id == filterStore.storeIds[0]) {
      console.log(v);
      // 从店铺列表数据中取出店长那条数据
      return v;
    }
  });
  return handStore[0];
}
const state = {
  keepAlive: ['PrescriptionList', 'shopManagement', 'staffManagement'], // 无用 迁移至tagsViews
  userInfo: null, // 用户信息
  warnState: false, // 警告窗状态
  placeCode: null, // 监管账号省市区编码
  companyId: null, // 公司Id
  companyName: null, // 公司名称
  storeList: null, // 店铺列表
  userName: null, // 用户名称
  userId: null, // 用户id
  ucUserId: null, // 用户中心id
  refusedStoreList: null, // 驳回列表
  fileDomain: null, // 文件头
  displayConfig: null, // 后台返回展示配置
  onlineStatus: null, // 用户在线离线状态，1-在线,0-离线，返回空时不展示该项
  notification: false, // 默认不展示通知
  storeAccoutnInfo: null, // 店铺账户数据
  roleListFromBk: null, // 后台拿到的原始数据
  store_managerStoreInfo: null, // 店长店铺数据
  punchState: null, // 0-未打卡 1-已上班打卡 2-已下班打卡
  isChain: null, // 是否连锁药店,1是，0-不是
  roleStore: null, // 获取角色下的药店
  storeInfo: null, // 药店信息
  mobile: null, // 电话
  needIdNo: true, // 是否强制身份证
  saleInfo: {}, // 登录人对应的销售信息
  companyRepHasRenewalEntrance: null, // 登陆人是否有续费入口
  exportTypeList: [], // 下载类型枚举
  prescriptionTemplate: 0, // 0=老打印，1=新打印

  // 系统横幅配置
  bannerConfig: {
    text: '',
    visible: false, // 是否显示横幅
    closable: false, // 是否可关闭
    type: 'info', // 横幅类型：info, warning, error
    autoScroll: true, // 是否自动滚动
    todayToast: true, // 今日是否已弹窗 默认设置为弹过了
    modalTitle: '续费提醒',
    renewalQrCodeUrl: null // 二维码地址
  }
};

const getters = {
  allowedConsultTypes(state) {
    const { applyType } = state.storeInfo || {};
    const { DIRECT_CONSULT, SIMPLE_CONSULT, VIDEO_CONSULT, PHOTO_CONSULT } = CONSULT_TYPE;
    return {
      allowDirectConsult: (applyType & DIRECT_CONSULT) === DIRECT_CONSULT,
      allowsimpleConsult: (applyType & SIMPLE_CONSULT) === SIMPLE_CONSULT,
      allowVideoConsult: (applyType & VIDEO_CONSULT) === VIDEO_CONSULT,
      allowPhotoConsult: (applyType & PHOTO_CONSULT) === PHOTO_CONSULT
    };
  }
};
const mutations = {
  SET_KEEP_ALIVE: (state, keepAlive) => {
    state.keepAlive = keepAlive;
  },
  SETINFO: (state, info) => {
    // 获取用户接口调用传进来的数据
    state.userInfo = info;
    state.companyName = info.companyName;
    state.placeCode = info.placeCode;
    state.storeList = info.storeList;
    state.userName = info.userName;
    state.refusedStoreList = info.refusedStoreList;
    state.fileDomain = info.displayConfig.fileDomain;
    state.displayConfig = info.displayConfig;
    state.userId = info.userId;
    state.ucUserId = info.ucUserId;
    state.onlineStatus = info.onlineStatus;
    state.roleListFromBk = info.roleList;
    state.isChain = info.isChain;
    state.companyId = info.companyId;
    state.storeInfo = info.storeInfo;
    state.mobile = info.mobile;
    state.companyRepHasRenewalEntrance = info.companyRepHasRenewalEntrance;
    state.exportTypeList = info.exportTypeList;
    state.prescriptionTemplate = info.prescriptionTemplate || 0;
    setTimeout(() => {
      // 最后赋值 不然用户角色取不到
      state.store_managerStoreInfo = findStoreMana(info);
    }, 0);
    let len = info.refusedStoreList != 0;
    store.commit('global/SETwarnState', len);
    store.commit('global/SETroleStore', info);
    try {
      Telescope.login({ uid: state.ucUserId });
    } catch (err) {}
  },
  SETwarnState: (state, status) => {
    // 设置警告窗状态
    if (state.refusedStoreList.length == 0) {
      state.warnState = false;
    } else {
      state.warnState = status;
    }
  },
  SETnotification(st, status) {
    st.notification = status;
  },
  SETstoreAccoutnInfo(st, data) {
    st.storeAccoutnInfo = data;
  },
  SETpunchState(state, punchState) {
    state.punchState = punchState;
  },
  // 设置角色所属药店
  SETroleStore(state, data) {
    const { roleList, storeList } = data;
    const role = find(roleList, role => role.storeIds.length > 0);
    if (role) state.roleStore = find(storeList, store => store.id === role.storeIds[0]);
  },
  SET_NEED_IDNO(st, payload) {
    st.needIdNo = payload;
  },
  SET_SALE_INFO(state, payload) {
    state.saleInfo = payload;
  },
  setPrescriptionTmpl(state, payload) {
    state.prescriptionTemplate = payload;
  },
  // 横幅相关 mutations
  SET_BANNER_CONFIG: (state, config) => {
    state.bannerConfig = { ...state.bannerConfig, ...config };
  },
  SET_BANNER_VISIBLE: (state, visible) => {
    state.bannerConfig.visible = visible;
  },
  SET_BANNER_TEXT: (state, text) => {
    state.bannerConfig.text = text;
  },
  SET_BANNER_CLOSABLE: (state, closable) => {
    state.bannerConfig.closable = closable;
  }
};

const actions = {
  async getPackageRenewalNotify({ commit, state, rootState }) {
    const { permission } = rootState;
    const { roles } = permission;
    if (roles.includes(Constant.RoleList.d) || roles.includes(Constant.RoleList.a)) {
      console.log('有权限请求');
      const res = await getPackageRenewalNotify();
      console.log('res = ', res);
      const { showNotifyInfo, todayNotify, notifyInfo, renewalQrCodeUrl } = res;

      const data = Object.assign({}, state.bannerConfig, {
        text: notifyInfo,
        visible: showNotifyInfo,
        todayToast: todayNotify,
        renewalQrCodeUrl
      });
      console.log('data = ', data);
      commit('SET_BANNER_CONFIG', data);
    }
  },
  SETnotification({ commit }, status) {
    commit('SETnotification', status);
  },
  async SETstoreAccoutnInfo({ commit }) {
    // 获取店铺账户信息
    let res = await Fetch.store_account_info_pc();
    commit('SETstoreAccoutnInfo', res);
  },
  async SETpunchState({ commit }) {
    const punchState = await Fetch.get_punch_detail();
    commit('SETpunchState', punchState.punchType);
    return punchState.punchType;
  },

  // 获取强制身份证白名单
  async setNeedIdNo({ commit, state }) {
    // 兼容后端初始化接口没返回storeid
    const bizId = state.store_managerStoreInfo ? state.store_managerStoreInfo.id : state.storeList[0].id;
    const { needIdNo = false } = await Fetch.check_need_id_no({ bizId });
    if (needIdNo === state.needIdNo) return;
    commit('SET_NEED_IDNO', needIdNo);
  },
  // 自动更新经纬度
  async autoUpdateDistance() {
    console.log('--- 调用自动更新 ---');
    let result;
    try {
      let res = await getLocationByAMap();
      result = res.result;
    } catch (e) {
      return;
      // console.warn(e);
      // Message({
      //   message: (e && e.msg) || '加载定位组件失败，请刷新浏览器重试一下',
      //   type: 'error'
      // });
    }

    console.log('result = ', result);
    const {
      position: { lng, lat }
    } = result;
    let res = await Fetch.auto_update_store_longitudeLatitude({
      longitudeLatitude: `${lng},${lat}`
    });
    return res;
  },
  async checkDistance({ rootState }) {
    // code 0 通过  1 未设置 2 不在店内
    let result;
    try {
      let res = await getLocationByAMap();
      result = res.result;
    } catch (e) {
      // console.warn(e);
      // Message({
      //   message: (e && e.msg) || '加载定位组件失败，请刷新浏览器重试一下',
      //   type: 'error'
      // });
      return true;
    }

    const {
      position: { lng, lat }
    } = result;
    const { code } = await Fetch.check_distance_and_whiteList({
      longitudeLatitude: `${lng},${lat}`,
      applySource: 1
    });
    console.log('checkDistance code', code);
    if (code === 0) {
      return true;
    }
    const roleList = rootState.permission.roles || [];
    const msgOptions = getFailDistanceMsg(roleList, code);
    console.log('msgOptions = ', msgOptions);
    if (!msgOptions) {
      return true;
    }
    try {
      await msgDialog.show(msgOptions);
      msgOptions.push && router.push(msgOptions.push);
    } catch (err) {
      console.log('msgDialog err = ', err);
      // cancel
      return false;
    }
    return false;
  },
  async getSaleInfo({ commit }) {
    const res = await Fetch.getSaleInfo();
    commit('SET_SALE_INFO', res);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
